@if (isVisible) {
  <div class="grid-x" [formGroup]="formGroup">
    <div class="cell">
      <form-control-label [question]="componentData" [flow]="flowComponent"></form-control-label>

      <common-date-picker class="screen-only" [id]="controlId" [disabled]="isEnabled === false" [daysPast]="maxDaysPast" [placeholder]="placeholder" [daysFuture]="maxDaysFuture" [initialDate]="dateModel" (dateUpdated)="dateChanged($event)"></common-date-picker>
      <div class="print-only">{{contextValue | date: 'MM/dd/yyyy'}}</div>
    </div>
  </div>
}
